import { describe, type ValidationMap } from '@elliemae/ds-props-helpers';
import { DSTabPropTypes } from '../react-desc-prop-types.js';
import type { DSTabT } from '../react-desc-prop-types.js';

// const DSTab = (props: DSTabT.Props): JSX.Element => <React.Fragment {...props} />;
const DSTab = (props: DSTabT.Props) => props.children;

DSTab.displayName = 'DSTab';
const DSTabWithSchema = describe(DSTab);
DSTabWithSchema.propTypes = DSTabPropTypes as unknown as ValidationMap<DSTabT.Props>;

export { DSTab, DSTabWithSchema };
export default DSTab;
